/*
  Akademie-Übungen (27.10.2026 v2, 28.10.2026 v3 nach content/training/_ux-guide-hub.md, 28.10.2026 v4 Akademie):
  Kartenanimation, Kachelzahlen, „Neueste Übungen" und Hub-Filter.
  Eingebunden von sections/training-hub.liquid (/pages/uebungen), sections/akademie-hub.liquid (/pages/akademie) und
  sections/blog-training.liquid (Übungs-Blog und Tag-Seiten). Keine festen Blog-Pfade: Karten-URLs kommen aus dem Index
  (tools/training/training_index.py baut sie aus dem echten Blog-Handle) bzw. aus dem Liquid-Markup (data-url).

  1. Kartenanimation (Markup: snippets/training-karte.liquid)
     Karten MIT Karten-SVG (img.trk__karte) animieren von selbst (die SVG läuft als <img> in Schleife), hier nichts zu tun.
     Karten OHNE Karten-SVG (.trk--alt, Übergang bis Metafeld training.karte_svg_url gesetzt ist):
     Desktop (Hover und Maus): Hover oder Tastaturfokus zeigt die animierte SVG der Übung über dem Artikelbild.
     Touch: Tipp auf das Play-Symbol zeigt die Animation, der zweite Tipp auf dasselbe Symbol öffnet die Übung.
     Die SVG kommt per fetch von <artikel-url>?view=svg (templates/article.svg.liquid), einmal je Übung, danach aus dem Speicher.
     Höchstens 3 Karten animieren gleichzeitig (die älteste stoppt), Karten außerhalb des Bildschirms stoppen.

  1b. Dropdowns als <details> (Tag-Seiten; Hub, bis der Index geladen ist): schließen bei Klick außerhalb und Escape,
      immer nur einer offen. Die Einträge sind Links auf die Tag-Seiten.

  1c. Index (assets/training-index.json, tools/training/training_index.py), Quelle: data-index am Hub oder data-trk-index
      (Akademie). Damit:
      - Kacheln (snippets/training-kacheln.liquid): Zahl je [data-trq-tag] aus dem Index.
      - „Neueste Übungen" ([data-trn], Akademie): die ersten data-anzahl Übungen als Karten.
      - Akademie-Kachel „Übungen" ([data-tra-karte]): Karten-SVG der neuesten Übung mit Feld „karte".
      Karten-Chips: Anzeige-Tabellen aus <script data-trk-tags> (snippets/training-tags-json.liquid).
      Schwierigkeit (28.10.2026): Index-Feld stufe (1 bis 3, sonst Tag aus der Gruppe stufe) als drei Balken rechts im Kartenfuß
      (Funktion stufeHtml, Markup wie snippets/training-stufe.liquid).

  2. Hub-Filter (nur mit [data-trh-app])
     Baut jeden Dropdown zu Knopf + Popover um und übernimmt Suche, aktive Filter-Chips, Sortierung, Raster.
     Schlägt das Laden fehl, bleibt alles wie ohne JavaScript (Links).
     data-modus="einfach" (Altersklasse, Schwerpunkt, Trainingsphase): Radio-Liste mit „Alle" und Trefferzahlen. Klick (oder Leertaste,
       Enter) wählt, wendet sofort an und schließt, auch im Bottom-Sheet. Pfeiltasten wählen ohne zu schließen (Radio-Semantik).
     data-modus="mehrfach" (Mehr): Checkboxen; Desktop filtert sofort, mobil (Bottom-Sheet) ist die Auswahl ein Entwurf bis
       „Übernehmen"; Schließen verwirft, „Zurücksetzen" leert den Dropdown.
     Desktop (ab 760 px): Popover unter dem Knopf; schließt bei Klick außerhalb, Escape, Tab hinaus. Mobil: Bottom-Sheet.
     Knopf-Label: „Altersklasse" / „Altersklasse: E-Jugend" / „Mehr (2)".
     Zählung: Trefferzahl je Option ohne die eigene Gruppe (in einer Gruppe ODER, zwischen Gruppen UND); 0 Treffer = gesperrt.
     URL: je Gruppe data-param mit Tag-Handles (kommagetrennt; einfach = ein Handle), q = Suchtext, sort = dauer|titel|stufe.
     „Mehr" enthält seit 28.10.2026 die Gruppe Schwierigkeit (data-param stufe, Optionen mit Balken). Sortierung
     „Schwierigkeit aufsteigend" (sort=stufe): Stufe 1 zuerst, Übungen ohne Stufe ans Ende, sonst Index-Reihenfolge.
     Fremde Parameter (view, preview_theme_id, …) bleiben erhalten; History per replaceState.
*/
(function () {
  'use strict';

  var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var REDUZIERT = mm('(prefers-reduced-motion: reduce)').matches;
  var HOVER = mm('(hover: hover) and (pointer: fine)').matches;
  var MAX_ANIM = 3;
  var VORSCHAU = new URLSearchParams(location.search).get('preview_theme_id');
  var KARTE_ALT = '.trk--alt[data-trk]';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function uebungenText(n) { return n + (n === 1 ? ' Übung' : ' Übungen'); }

  /* ---------- 1. Kartenanimation (nur Karten ohne Karten-SVG) ---------- */

  var svgSpeicher = {};   // Artikel-URL -> Promise<String>
  var laufend = [];       // Karten mit sichtbarer Animation, älteste zuerst
  var hoverKarte = null;
  var beobachter = null;

  function svgLaden(url) {
    if (!svgSpeicher[url]) {
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=svg' + (VORSCHAU ? '&preview_theme_id=' + encodeURIComponent(VORSCHAU) : '');
      svgSpeicher[url] = fetch(u, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) {
          var i = t.indexOf('<svg'), j = t.indexOf('</svg>', i);
          if (i < 0 || j < 0) throw new Error('keine SVG');
          return t.slice(i, j + 6);
        });
    }
    return svgSpeicher[url];
  }

  function svgEinsetzen(karte, text) {
    var ziel = karte.querySelector('[data-trk-anim]');
    if (!ziel) return null;
    if (!karte._svg) {
      ziel.innerHTML = text;
      var svg = ziel.querySelector('svg');
      if (!svg) return null;
      svg.removeAttribute('style');
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      karte._svg = svg;
    } else if (!karte._svg.parentNode) {
      ziel.appendChild(karte._svg); // neu einhängen: CSS-Animation startet von vorn
    }
    return karte._svg;
  }

  function starten(karte) {
    if (!karte || karte._fehler || !karte.querySelector('[data-trk-anim]')) return;
    karte._soll = true;
    karte.classList.add('trk--laedt');
    svgLaden(karte.getAttribute('data-url')).then(function (text) {
      karte.classList.remove('trk--laedt');
      if (!karte._soll) return;
      if (!svgEinsetzen(karte, text)) throw new Error('keine SVG');
      karte.classList.add('trk--anim');
      var i = laufend.indexOf(karte);
      if (i > -1) laufend.splice(i, 1);
      laufend.push(karte);
      while (laufend.length > MAX_ANIM) stoppen(laufend[0]);
      if (beobachter) beobachter.observe(karte);
    }).catch(function () {
      karte.classList.remove('trk--laedt');
      karte._fehler = true;
      karte.classList.add('trk--fehler');
      setzePlay(karte, false);
    });
  }

  function stoppen(karte) {
    if (!karte) return;
    karte._soll = false;
    karte.classList.remove('trk--anim', 'trk--laedt');
    var i = laufend.indexOf(karte);
    if (i > -1) laufend.splice(i, 1);
    setzePlay(karte, false);
    if (beobachter) beobachter.unobserve(karte);
    // nach dem Ausblenden aushängen, damit die Animation beim nächsten Start von vorn läuft
    var svg = karte._svg;
    if (svg) setTimeout(function () { if (!karte._soll && svg.parentNode) svg.parentNode.removeChild(svg); }, 250);
  }

  function setzePlay(karte, an) {
    var b = karte.querySelector('[data-trk-play]');
    if (!b) return;
    b.setAttribute('aria-pressed', an ? 'true' : 'false');
    var titel = karte.getAttribute('data-titel') || (karte.querySelector('.trk__titel') || {}).textContent || '';
    b.setAttribute('aria-label', (an ? 'Übung öffnen: ' : 'Animation zeigen: ') + titel.trim());
  }

  function kartenAktivieren(wurzel) {
    var knoepfe = (wurzel || document).querySelectorAll(KARTE_ALT + ' [data-trk-play]');
    for (var i = 0; i < knoepfe.length; i++) knoepfe[i].hidden = false;
  }

  if ('IntersectionObserver' in window) {
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (!e.isIntersecting) stoppen(e.target); });
    });
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-trk-play]');
    if (!b) return;
    var karte = b.closest('.trk');
    if (!karte) return;
    ev.preventDefault();
    if (b.getAttribute('aria-pressed') === 'true') {
      location.href = karte.getAttribute('data-url');
      return;
    }
    if (hoverKarte && hoverKarte !== karte) { stoppen(hoverKarte); hoverKarte = null; }
    setzePlay(karte, true);
    starten(karte);
  });

  if (HOVER && !REDUZIERT) {
    document.addEventListener('mouseover', function (ev) {
      var karte = ev.target.closest && ev.target.closest(KARTE_ALT);
      if (!karte || karte === hoverKarte) return;
      if (hoverKarte) stoppen(hoverKarte);
      hoverKarte = karte;
      starten(karte);
    });
    document.addEventListener('mouseout', function (ev) {
      if (!hoverKarte) return;
      var nach = ev.relatedTarget;
      if (nach && hoverKarte.contains(nach)) return;
      if (!ev.target.closest || ev.target.closest(KARTE_ALT) !== hoverKarte) return;
      stoppen(hoverKarte);
      hoverKarte = null;
    });
    document.addEventListener('focusin', function (ev) {
      var karte = ev.target.closest && ev.target.closest(KARTE_ALT);
      if (karte && ev.target.classList.contains('trk__link')) starten(karte);
    });
    document.addEventListener('focusout', function (ev) {
      var karte = ev.target.closest && ev.target.closest(KARTE_ALT);
      if (karte && !karte.contains(ev.relatedTarget) && karte !== hoverKarte) stoppen(karte);
    });
  }

  kartenAktivieren(document);

  /* ---------- 1b. Dropdowns als <details> (ohne Filter-JS) ---------- */

  function offeneDetails() { return document.querySelectorAll('details[data-trd][open]'); }
  document.addEventListener('click', function (ev) {
    Array.prototype.forEach.call(offeneDetails(), function (d) { if (!d.contains(ev.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    Array.prototype.forEach.call(offeneDetails(), function (d) {
      d.open = false;
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
  // toggle blubbert nicht, kommt aber in der Capture-Phase an: immer nur ein Dropdown offen
  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (!d || !d.matches || !d.matches('details[data-trd]') || !d.open) return;
    Array.prototype.forEach.call(offeneDetails(), function (x) { if (x !== d) x.open = false; });
  }, true);

  /* ---------- 1c. Index, Karten aus dem Index, Kacheln, Neueste ---------- */

  if (!window.fetch || !window.URLSearchParams) return;
  var app = document.querySelector('[data-trh-app]');
  var indexEl = app || document.querySelector('[data-trk-index]');
  if (!indexEl) return;
  var INDEX_URL = indexEl.getAttribute(app ? 'data-index' : 'data-trk-index');
  if (!INDEX_URL) return;

  // Anzeige-Tabellen für die Karten-Chips: [[Anzeige, Tag], …] je Gruppe
  var TAGS = { altersklasse: [], schwerpunkt: [], stufe: [['Einsteiger', 'Einsteiger'], ['Fortgeschritten', 'Fortgeschritten'], ['Anspruchsvoll', 'Anspruchsvoll']] };
  (function () {
    var s = document.querySelector('script[data-trk-tags]');
    if (!s) return;
    try {
      var j = JSON.parse(s.textContent);
      TAGS.altersklasse = j.altersklasse || [];
      TAGS.schwerpunkt = j.schwerpunkt || [];
      if (j.stufe && j.stufe.length === 3) TAGS.stufe = j.stufe;
    } catch (e) { /* bleibt leer */ }
  })();

  /* Schwierigkeit: Index-Feld stufe (1 bis 3), sonst der erste Stufen-Tag; 0 = keine Stufe */
  function stufeVon(u) {
    var n = parseInt(u.stufe, 10);
    if (n >= 1 && n <= 3) return n;
    for (var k = 0; k < TAGS.stufe.length; k++) if (u._tags[TAGS.stufe[k][1]]) return k + 1;
    return 0;
  }
  /* drei Balken wie snippets/training-stufe.liquid; o = {variante, klein, deko, name, klasse} */
  function stufeHtml(n, o) {
    o = o || {};
    if (!(n >= 1 && n <= 3)) return '';
    var name = (TAGS.stufe[n - 1] || [])[0] || '';
    var label = 'Stufe ' + n + ' von 3, ' + name;
    var b = '';
    for (var i = 1; i <= 3; i++) b += '<span class="trst__b' + (i <= n ? ' trst__b--an' : '') + '"></span>';
    return '<span class="trst trst--' + (o.variante || 'hell') + (o.klein ? ' trst--klein' : '') + (o.klasse ? ' ' + o.klasse : '') + '" data-stufe="' + n + '">' +
      '<span class="trst__balken"' + (o.deko ? ' aria-hidden="true"' : ' role="img" aria-label="' + esc(label) + '" title="' + esc(label) + '"') + '>' + b + '</span>' +
      (o.name ? '<span class="trst__name"' + (o.deko ? '' : ' aria-hidden="true"') + '>' + esc(name) + '</span>' : '') + '</span>';
  }

  function erstesLabel(u, key, ersatz) {
    var l = TAGS[key] || [];
    for (var k = 0; k < l.length; k++) if (u._tags[l[k][1]]) return l[k][0];
    return ersatz || '';
  }
  function dauerKurz(d) {
    d = String(d || '');
    return d.indexOf('Minuten') > -1 ? d.split('Minuten')[0].trim() + ' Min.' : d;
  }
  function kurzTitel(t) {
    var k = String(t || '').split(':')[0].trim();
    return k || String(t || '');
  }
  function bildUrl(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var PLAY = '<svg class="trk__play-icon trk__play-icon--start" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>' +
    '<svg class="trk__play-icon trk__play-icon--auf" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12h12M12 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Karte wie snippets/training-karte.liquid */
  function karteHtml(u, nr) {
    var alter = erstesLabel(u, 'altersklasse', u.altersklasse);
    var schwer = erstesLabel(u, 'schwerpunkt', u.schwerpunkt);
    var dauer = dauerKurz(u.dauer);
    var kurz = kurzTitel(u.title);
    var laden = nr < 4 ? 'eager' : 'lazy';
    var media = '';
    if (u.karte) {
      media = '<img class="trk__karte" src="' + esc(u.karte) + '" width="400" height="300" alt="" loading="' + laden + '" decoding="async">';
    } else {
      if (u.image) {
        media = '<img class="trk__bild" src="' + esc(bildUrl(u.image, 700)) + '" srcset="' + [350, 500, 700, 1000].map(function (w) { return esc(bildUrl(u.image, w)) + ' ' + w + 'w'; }).join(', ') +
          '" sizes="(min-width: 1100px) 515px, (min-width: 760px) 50vw, 100vw" width="700" height="700" alt="" loading="' + laden + '" decoding="async">';
      }
      media += '<span class="trk__anim" aria-hidden="true" data-trk-anim></span>';
    }
    var titel = kurz === u.title
      ? '<strong class="trk__titel">' + esc(u.title) + '</strong>'
      : '<strong class="trk__titel"><span aria-hidden="true">' + esc(kurz) + '</span><span class="sr-only">' + esc(u.title) + '</span></strong>';
    var chips = '';
    if (alter) chips += '<span class="trk__chip trk__chip--voll">' + esc(alter) + '</span>';
    if (schwer) chips += '<span class="trk__chip">' + esc(schwer) + '</span>';
    if (dauer) chips += '<span class="trk__chip trk__chip--dauer">' + esc(dauer) + '</span>';
    chips += stufeHtml(stufeVon(u), { variante: 'dunkel', klein: true, klasse: 'trk__stufe' });
    return '<div class="trk' + (u.karte ? '' : ' trk--alt') + '" data-trk data-url="' + esc(u.url) + '" data-titel="' + esc(u.title) + '">' +
      '<a class="trk__link" href="' + esc(u.url) + '" title="' + esc(u.title) + '">' +
      '<span class="trk__kopf">' + titel + '</span>' +
      '<span class="trk__media">' + media + '</span>' +
      (chips ? '<span class="trk__fuss">' + chips + '</span>' : '') + '</a>' +
      (u.karte ? '' : '<button class="trk__play" type="button" aria-pressed="false" aria-label="Animation zeigen: ' + esc(u.title) + '" data-trk-play>' + PLAY + '</button>') +
      '</div>';
  }

  function kachelnZaehlen(uebungen) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-trq-tag]'), function (el) {
      var tag = el.getAttribute('data-trq-tag'), n = 0;
      uebungen.forEach(function (u) { if (u._tags[tag]) n++; });
      el.textContent = n ? uebungenText(n) : 'Noch keine Übung';
      var k = el.closest('.trq__kachel');
      if (k) k.classList.toggle('trq__kachel--leer', n === 0);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tra-zahl]'), function (el) { el.textContent = uebungenText(uebungen.length); });
  }

  function neuesteZeichnen(uebungen) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-trn]'), function (box) {
      var n = parseInt(box.getAttribute('data-anzahl'), 10) || 5;
      var liste = uebungen.slice(0, n);
      if (!liste.length) return;
      var cta = box.querySelector('[data-trn-cta]');
      box.innerHTML = liste.map(karteHtml).join('');
      if (cta) box.appendChild(cta);
      var leer = box.parentNode && box.parentNode.querySelector('[data-trn-leer]');
      if (leer) leer.hidden = true;
      box.hidden = false;
      kartenAktivieren(box);
    });
    var mit = null;
    for (var i = 0; i < uebungen.length; i++) if (uebungen[i].karte) { mit = uebungen[i]; break; }
    if (!mit) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-tra-karte]'), function (fl) {
      fl.innerHTML = '<img class="tra__karte" src="' + esc(mit.karte) + '" width="400" height="300" alt="" decoding="async">';
    });
  }

  var uebungen = [];
  var indexFertig = fetch(INDEX_URL, { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function (daten) {
      if (!Array.isArray(daten)) throw new Error('Index ist keine Liste');
      uebungen = daten.map(function (u, i) {
        u._pos = i;
        u._tags = {};
        (u.tags || []).forEach(function (t) { u._tags[t] = true; });
        u._text = norm([u.title, u.summary, (u.tags || []).join(' '), u.schwerpunkt, (u.material || []).join(' ')].join(' '));
        return u;
      });
      if (!uebungen.length) return uebungen; // leerer Index: Liquid-Fassung bleibt stehen
      kachelnZaehlen(uebungen);
      neuesteZeichnen(uebungen);
      return uebungen;
    });
  indexFertig.catch(function (e) {
    if (window.console) console.warn('Akademie: Index nicht geladen, Liquid-Fassung bleibt stehen.', e);
  });

  /* ---------- 2. Hub-Filter ---------- */

  if (!app) return;

  var PRO_SEITE = parseInt(app.getAttribute('data-pro-seite'), 10) || 24;
  var SHEET = mm('(max-width: 759px)');
  var filterBox = app.querySelector('[data-trf]');
  var eingabe = app.querySelector('[data-trs-q]');
  var formular = app.querySelector('[data-trs]');
  var raster = app.querySelector('[data-trr-grid]');
  var zahl = app.querySelector('[data-trr-zahl]');
  var sortWahl = app.querySelector('[data-trr-sort]');
  var sortBox = app.querySelector('[data-trr-sortwrap]');
  var leer = app.querySelector('[data-trr-leer]');
  var mehrBtn = app.querySelector('[data-trr-mehr]');
  var aktivBox = app.querySelector('[data-trf-aktiv]');
  var resetLinks = app.querySelectorAll('[data-trf-reset]');
  if (!raster || !filterBox) return;
  if (!zahl) {
    // Hub ohne veröffentlichte Übung: Liquid lässt die Zahl weg, das JS braucht sie trotzdem
    zahl = document.createElement('p');
    zahl.className = 'trf__zahl';
    zahl.setAttribute('aria-live', 'polite');
    var rechts = filterBox.querySelector('.trf__rechts');
    if (rechts) rechts.insertBefore(zahl, sortBox || null);
  }

  var PFEIL = '<svg class="trd__pfeil" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true" focusable="false"><path d="M1 1.5 6 6.5 11 1.5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var zustand = { q: '', sort: 'neu', wahl: {}, sichtbar: PRO_SEITE };
  var dds = [];       // {el, key, titel, einfach, gruppen, knopf, pop, label, treffer}
  var gruppen = [];   // {key, param, titel, dd, optionen: [{tag, handle, label, cb, li, nEl}], alle: {cb, li, nEl}}
  var offen = null;   // {dd, sheet, entwurf: {param: [tags]}}
  var urlTimer = null;
  var pfeilTaste = false;

  Array.prototype.forEach.call(filterBox.querySelectorAll('[data-trd]'), function (d) {
    var dd = { el: d, key: d.getAttribute('data-dd'), titel: d.getAttribute('data-titel'), einfach: d.getAttribute('data-modus') === 'einfach', gruppen: [] };
    Array.prototype.forEach.call(d.querySelectorAll('[data-gruppe]'), function (g) {
      var gr = { key: g.getAttribute('data-gruppe'), param: g.getAttribute('data-param'), titel: g.getAttribute('data-titel'), dd: dd, optionen: [] };
      Array.prototype.forEach.call(g.querySelectorAll('.trd__opt'), function (o) {
        gr.optionen.push({ tag: o.getAttribute('data-tag'), handle: o.getAttribute('data-handle'), label: o.textContent.trim() });
      });
      zustand.wahl[gr.param] = [];
      dd.gruppen.push(gr);
      gruppen.push(gr);
    });
    dds.push(dd);
  });

  /* Zustand aus der URL (Einfachauswahl: nur der erste passende Handle) */
  function ausUrl() {
    var p = new URLSearchParams(location.search);
    zustand.q = (p.get('q') || '').trim();
    var s = p.get('sort');
    zustand.sort = (s === 'dauer' || s === 'titel' || s === 'stufe') ? s : 'neu';
    gruppen.forEach(function (g) {
      var handles = (p.get(g.param) || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      var w = g.optionen.filter(function (o) { return handles.indexOf(o.handle) > -1; }).map(function (o) { return o.tag; });
      zustand.wahl[g.param] = g.dd.einfach ? w.slice(0, 1) : w;
    });
  }

  function inUrl(sofort) {
    clearTimeout(urlTimer);
    var schreiben = function () {
      var p = new URLSearchParams(location.search);
      gruppen.forEach(function (g) {
        var h = g.optionen.filter(function (o) { return zustand.wahl[g.param].indexOf(o.tag) > -1; }).map(function (o) { return o.handle; });
        if (h.length) p.set(g.param, h.join(',')); else p.delete(g.param);
      });
      if (zustand.q) p.set('q', zustand.q); else p.delete('q');
      if (zustand.sort !== 'neu') p.set('sort', zustand.sort); else p.delete('sort');
      p.delete('page');
      var qs = p.toString().replace(/%2C/gi, ',');
      try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) { /* z. B. Sandbox */ }
    };
    if (sofort) schreiben(); else urlTimer = setTimeout(schreiben, 300);
  }

  /* Filtern */
  function suchePasst(u, woerter) {
    for (var i = 0; i < woerter.length; i++) if (u._text.indexOf(woerter[i]) < 0) return false;
    return true;
  }
  function passt(u, woerter, ohneParam, wahl) {
    if (woerter.length && !suchePasst(u, woerter)) return false;
    for (var i = 0; i < gruppen.length; i++) {
      var g = gruppen[i];
      if (g.param === ohneParam) continue;
      var w = wahl[g.param];
      if (!w || !w.length) continue;
      var ok = false;
      for (var k = 0; k < w.length; k++) if (u._tags[w[k]]) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }
  function suchWoerter() {
    return norm(zustand.q).split(/\s+/).filter(Boolean);
  }
  function hatAuswahl() {
    if (zustand.q) return true;
    return gruppen.some(function (g) { return zustand.wahl[g.param].length > 0; });
  }
  // Auswahl, die Häkchen und Zahlen zeigen: im offenen Bottom-Sheet (Mehrfachauswahl) der Entwurf, sonst die angewendete Auswahl
  function anzeigeWahl() {
    if (!offen || !offen.sheet || offen.dd.einfach) return zustand.wahl;
    var w = {};
    for (var p in zustand.wahl) w[p] = offen.entwurf[p] || zustand.wahl[p];
    return w;
  }

  function sortiert(liste) {
    var l = liste.slice();
    if (zustand.sort === 'dauer') {
      l.sort(function (a, b) {
        var da = a.dauer_min == null ? Infinity : a.dauer_min, db = b.dauer_min == null ? Infinity : b.dauer_min;
        return da - db || a._pos - b._pos;
      });
    } else if (zustand.sort === 'stufe') {
      l.sort(function (a, b) {
        var sa = stufeVon(a) || Infinity, sb = stufeVon(b) || Infinity;
        return (sa === sb ? 0 : sa - sb) || a._pos - b._pos;
      });
    } else if (zustand.sort === 'titel') {
      l.sort(function (a, b) { return a.title.localeCompare(b.title, 'de', { sensitivity: 'base', numeric: true }) || a._pos - b._pos; });
    } else {
      l.sort(function (a, b) {
        var pa = a.published_at || '', pb = b.published_at || '';
        if (pa !== pb && pa && pb) return pa < pb ? 1 : -1;
        return a._pos - b._pos; // Index ist bereits neueste zuerst sortiert
      });
    }
    return l;
  }

  /* Dropdowns: <details> zu Knopf + Popover umbauen (einfach: Radios mit „Alle", mehrfach: Checkboxen) */
  function ddUmbauen() {
    dds.forEach(function (dd) {
      var mehrere = dd.gruppen.length > 1;
      var popId = 'trd-pop-' + dd.key, titelId = 'trd-t-' + dd.key;
      var wrap = document.createElement('div');
      wrap.className = 'trd trd--js' + (dd.einfach ? ' trd--einfach' : ' trd--mehrfach');
      wrap.setAttribute('data-dd', dd.key);
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'trd__knopf';
      knopf.setAttribute('aria-expanded', 'false');
      knopf.setAttribute('aria-controls', popId);
      knopf.setAttribute('aria-haspopup', 'dialog');
      knopf.innerHTML = '<span class="trd__label"></span>' + PFEIL;
      var pop = document.createElement('div');
      pop.className = 'trd__pop';
      pop.id = popId;
      pop.hidden = true;
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-labelledby', titelId);
      var html = '<div class="trd__kopf"><p class="trd__titel" id="' + titelId + '">' + esc(dd.titel + (mehrere ? ' Filter' : '')) + '</p>' +
        '<p class="trd__treffer"></p><button type="button" class="trd__zu" aria-label="Schließen" data-trd-zu>×</button></div>' +
        '<div class="trd__gruppen' + (mehrere ? ' trd__gruppen--mehr' : '') + '">';
      dd.gruppen.forEach(function (g) {
        html += '<fieldset class="trd__gruppe"><legend class="' + (mehrere ? 'trd__g-titel' : 'sr-only') + '">' + esc(g.titel) + '</legend><ul class="trd__liste">';
        if (dd.einfach) {
          var name = 'trd-' + g.param;
          html += '<li><label class="trd__opt trd__opt--alle"><input class="trd__rb" type="radio" name="' + name + '" value="" data-param="' + esc(g.param) + '" data-tag="">' +
            '<span class="trd__name">Alle</span><span class="trd__n"></span></label></li>';
          g.optionen.forEach(function (o) {
            html += '<li><label class="trd__opt"><input class="trd__rb" type="radio" name="' + name + '" value="' + esc(o.handle) + '" data-param="' + esc(g.param) + '" data-tag="' + esc(o.tag) + '">' +
              '<span class="trd__name">' + esc(o.label) + '</span><span class="trd__n"></span></label></li>';
          });
        } else {
          g.optionen.forEach(function (o, i) {
            // Schwierigkeit: kleine Balken vor dem Namen (nur Dekoration, der Name steht als Text daneben)
            var balken = g.key === 'stufe' ? stufeHtml(i + 1, { variante: 'hell', klein: true, deko: true }) : '';
            html += '<li><label class="trd__opt"><input class="trd__cb" type="checkbox" data-param="' + esc(g.param) + '" data-tag="' + esc(o.tag) + '">' +
              balken + '<span class="trd__name">' + esc(o.label) + '</span><span class="trd__n"></span></label></li>';
          });
        }
        html += '</ul></fieldset>';
      });
      html += '</div>';
      if (!dd.einfach) {
        html += '<div class="trd__fuss"><button type="button" class="trd__reset" data-trd-reset>Zurücksetzen</button>' +
          '<button type="button" class="trd__ok" data-trd-ok>Übernehmen</button></div>';
      }
      pop.innerHTML = html;
      wrap.appendChild(knopf);
      wrap.appendChild(pop);
      dd.el.parentNode.replaceChild(wrap, dd.el);
      dd.el = wrap;
      dd.knopf = knopf;
      dd.pop = pop;
      dd.label = knopf.querySelector('.trd__label');
      dd.treffer = pop.querySelector('.trd__treffer');
      var inputs = pop.querySelectorAll('.trd__cb, .trd__rb'), k = 0;
      dd.gruppen.forEach(function (g) {
        if (dd.einfach) {
          var a = inputs[k++];
          g.alle = { cb: a, li: a.parentNode, nEl: a.parentNode.querySelector('.trd__n') };
        }
        g.optionen.forEach(function (o) {
          o.cb = inputs[k++];
          o.li = o.cb.parentNode;
          o.nEl = o.li.querySelector('.trd__n');
        });
      });
    });
  }

  /* Darstellung */
  function optionenZeichnen() {
    var woerter = suchWoerter();
    var w = anzeigeWahl();
    gruppen.forEach(function (g) {
      var basis = uebungen.filter(function (u) { return passt(u, woerter, g.param, w); });
      g.optionen.forEach(function (o) {
        var n = 0;
        for (var i = 0; i < basis.length; i++) if (basis[i]._tags[o.tag]) n++;
        var an = w[g.param].indexOf(o.tag) > -1;
        var aus = !an && n === 0;
        o.cb.checked = an;
        o.cb.disabled = aus;
        o.li.classList.toggle('trd__opt--aus', aus);
        o.nEl.textContent = n;
      });
      if (g.alle) {
        g.alle.cb.checked = w[g.param].length === 0;
        g.alle.nEl.textContent = basis.length;
      }
    });
    var t = uebungenText(uebungen.filter(function (u) { return passt(u, woerter, null, w); }).length);
    dds.forEach(function (dd) { dd.treffer.textContent = t; });
  }

  function knoepfeZeichnen() {
    dds.forEach(function (dd) {
      var gewaehlt = [];
      dd.gruppen.forEach(function (g) {
        g.optionen.forEach(function (o) { if (zustand.wahl[g.param].indexOf(o.tag) > -1) gewaehlt.push(o.label); });
      });
      var text = gewaehlt.length === 1 ? dd.titel + ': ' + gewaehlt[0] : gewaehlt.length > 1 ? dd.titel + ' (' + gewaehlt.length + ')' : dd.titel;
      dd.label.textContent = text;
      dd.knopf.title = gewaehlt.length > 1 ? dd.titel + ': ' + gewaehlt.join(', ') : text;
      dd.el.classList.toggle('trd--aktiv', gewaehlt.length > 0);
    });
  }

  function aktivZeichnen() {
    if (!aktivBox) return;
    var html = '';
    gruppen.forEach(function (g) {
      g.optionen.forEach(function (o) {
        if (zustand.wahl[g.param].indexOf(o.tag) < 0) return;
        html += '<button type="button" class="trf__chip-aktiv" data-param="' + esc(g.param) + '" data-tag="' + esc(o.tag) + '" aria-label="Filter entfernen: ' + esc(o.label) + '">' +
          esc(o.label) + '<span class="trf__chip-x" aria-hidden="true">×</span></button>';
      });
    });
    if (zustand.q) {
      html += '<button type="button" class="trf__chip-aktiv" data-q aria-label="Suche entfernen: ' + esc(zustand.q) + '">Suche: „' + esc(zustand.q) + '“<span class="trf__chip-x" aria-hidden="true">×</span></button>';
    }
    aktivBox.innerHTML = html;
  }

  function zeichnen(fokusAb) {
    var woerter = suchWoerter();
    var treffer = sortiert(uebungen.filter(function (u) { return passt(u, woerter, null, zustand.wahl); }));
    var akt = document.activeElement;
    var fokusOpt = akt && akt.classList && (akt.classList.contains('trd__cb') || akt.classList.contains('trd__rb')) ? akt : null;

    optionenZeichnen();
    knoepfeZeichnen();
    aktivZeichnen();
    zahl.textContent = uebungenText(treffer.length);

    var zeigen = treffer.slice(0, zustand.sichtbar);
    raster.innerHTML = zeigen.map(karteHtml).join('');
    raster.hidden = zeigen.length === 0;
    leer.hidden = treffer.length > 0;
    mehrBtn.hidden = treffer.length <= zustand.sichtbar;
    if (!mehrBtn.hidden) mehrBtn.textContent = 'Mehr laden (' + (treffer.length - zustand.sichtbar) + ' weitere)';
    Array.prototype.forEach.call(resetLinks, function (a) {
      if (a.closest('[data-trr-leer]')) return;
      a.hidden = !hatAuswahl();
    });
    laufend.slice().forEach(stoppen);
    hoverKarte = null;
    kartenAktivieren(raster);
    // fokussierte Option wurde gesperrt (0 Treffer): Fokus im Popover halten
    if (fokusOpt && fokusOpt.disabled && offen) fokusErstes(offen.dd);
    if (fokusAb != null) {
      var neu = raster.querySelectorAll('.trk__link')[fokusAb];
      if (neu) neu.focus({ preventScroll: false });
    }
  }

  function aendern(sofortUrl) {
    zustand.sichtbar = PRO_SEITE;
    zeichnen();
    inUrl(sofortUrl);
  }

  function zuruecksetzen() {
    zustand.q = '';
    if (eingabe) eingabe.value = '';
    gruppen.forEach(function (g) { zustand.wahl[g.param] = []; });
    aendern(true);
  }

  /* Popover und Bottom-Sheet */
  function fokusErstes(dd) {
    var x = dd.pop.querySelector('.trd__rb:checked') || dd.pop.querySelector('.trd__cb:not(:disabled), .trd__rb:not(:disabled)') || dd.pop.querySelector('[data-trd-ok], [data-trd-zu]');
    if (x) x.focus({ preventScroll: true });
  }
  function ausrichten(dd) {
    dd.pop.classList.remove('trd__pop--rechts');
    if (offen.sheet) return;
    var r = dd.pop.getBoundingClientRect();
    if (r.right > document.documentElement.clientWidth - 8) dd.pop.classList.add('trd__pop--rechts');
    // ragt das Popover unten aus dem Fenster: so weit scrollen, dass es ganz sichtbar ist; reicht der Platz nicht, kürzen
    if (r.bottom > window.innerHeight - 8) {
      dd.pop.scrollIntoView({ block: 'nearest' });
      r = dd.pop.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 8) dd.pop.style.maxHeight = Math.max(200, Math.floor(window.innerHeight - 12 - r.top)) + 'px';
    }
  }
  function oeffnen(dd) {
    if (offen) schliessen(false);
    offen = { dd: dd, sheet: SHEET.matches, entwurf: {} };
    if (offen.sheet && !dd.einfach) dd.gruppen.forEach(function (g) { offen.entwurf[g.param] = zustand.wahl[g.param].slice(); });
    dd.knopf.setAttribute('aria-expanded', 'true');
    dd.pop.hidden = false;
    if (offen.sheet) {
      dd.pop.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('trd-sperre');
    } else {
      dd.pop.removeAttribute('aria-modal');
    }
    optionenZeichnen();
    ausrichten(dd);
    fokusErstes(dd);
  }
  function schliessen(fokusZurueck) {
    if (!offen) return;
    var dd = offen.dd;
    offen = null; // ein offener Entwurf (Bottom-Sheet) ist damit verworfen
    dd.knopf.setAttribute('aria-expanded', 'false');
    dd.pop.hidden = true;
    dd.pop.classList.remove('trd__pop--rechts');
    dd.pop.style.maxHeight = '';
    document.documentElement.classList.remove('trd-sperre');
    optionenZeichnen();
    if (fokusZurueck) dd.knopf.focus();
  }
  function ddVon(el) {
    for (var i = 0; i < dds.length; i++) if (dds[i].el.contains(el)) return dds[i];
    return null;
  }

  function verdrahten() {
    dds.forEach(function (dd) {
      dd.knopf.addEventListener('click', function () {
        if (offen && offen.dd === dd) schliessen(false); else oeffnen(dd);
      });
      dd.el.addEventListener('focusout', function (ev) {
        // Desktop: mit Tab aus dem Popover heraus schließt es. Fokus auf einen Vorfahren (z. B. <main tabindex="-1"> beim
        // Klick auf eine Zeile im Popover) ist kein Verlassen.
        if (!offen || offen.dd !== dd || offen.sheet) return;
        var nach = ev.relatedTarget;
        if (nach && !dd.el.contains(nach) && !nach.contains(dd.el)) schliessen(false);
      });
    });

    // Einfachauswahl: change wendet an. Schließen über click (Maus, Tipp, Klick aufs Label, Leertaste; auch auf die schon gewählte
    // Option). Pfeiltasten wählen nach Radio-Semantik, ohne zu schließen (manche Browser schicken dabei ein click). Enter schließt.
    filterBox.addEventListener('keydown', function (ev) {
      if (!ev.target.classList || !ev.target.classList.contains('trd__rb')) return;
      if (/^Arrow/.test(ev.key)) { pfeilTaste = true; setTimeout(function () { pfeilTaste = false; }, 0); }
      if (ev.key === 'Enter') { ev.preventDefault(); schliessen(true); }
    });
    filterBox.addEventListener('click', function (ev) {
      if (!ev.target.classList || !ev.target.classList.contains('trd__rb') || pfeilTaste) return;
      setTimeout(function () { if (offen && offen.dd.einfach) schliessen(true); }, 0); // nach dem change-Ereignis
    });

    filterBox.addEventListener('change', function (ev) {
      var el = ev.target;
      if (!el.classList) return;
      var p = el.getAttribute('data-param'), t = el.getAttribute('data-tag');
      if (el.classList.contains('trd__rb')) {
        zustand.wahl[p] = t ? [t] : [];
        aendern(true);
        return;
      }
      if (!el.classList.contains('trd__cb')) return;
      var imSheet = offen && offen.sheet;
      var w = imSheet ? (offen.entwurf[p] || (offen.entwurf[p] = zustand.wahl[p].slice())) : zustand.wahl[p];
      var i = w.indexOf(t);
      if (el.checked && i < 0) w.push(t);
      if (!el.checked && i > -1) w.splice(i, 1);
      if (imSheet) optionenZeichnen(); else aendern(true);
    });

    filterBox.addEventListener('click', function (ev) {
      var x = ev.target.closest ? ev.target : null;
      if (!x) return;
      var dd = ddVon(x);
      if (x.closest('[data-trd-zu]')) { schliessen(true); return; }
      if (x.closest('[data-trd-ok]') && offen) {
        if (offen.sheet) {
          var entwurf = offen.entwurf;
          for (var p in entwurf) zustand.wahl[p] = entwurf[p].slice();
          schliessen(true);
          aendern(true);
        } else {
          schliessen(true);
        }
        return;
      }
      if (x.closest('[data-trd-reset]') && dd) {
        var imSheet = offen && offen.sheet;
        dd.gruppen.forEach(function (g) {
          if (imSheet) offen.entwurf[g.param] = []; else zustand.wahl[g.param] = [];
        });
        if (imSheet) optionenZeichnen(); else aendern(true);
        fokusErstes(dd);
        return;
      }
      var chip = x.closest('.trf__chip-aktiv');
      if (chip && aktivBox && aktivBox.contains(chip)) {
        var alle = Array.prototype.slice.call(aktivBox.querySelectorAll('.trf__chip-aktiv'));
        var nr = alle.indexOf(chip);
        if (chip.hasAttribute('data-q')) {
          zustand.q = '';
          if (eingabe) eingabe.value = '';
        } else {
          var wl = zustand.wahl[chip.getAttribute('data-param')];
          var k = wl.indexOf(chip.getAttribute('data-tag'));
          if (k > -1) wl.splice(k, 1);
        }
        aendern(true);
        var rest = aktivBox.querySelectorAll('.trf__chip-aktiv');
        var ziel = rest[Math.min(nr, rest.length - 1)] || (eingabe || dds[0].knopf);
        ziel.focus();
      }
    });

    // Desktop: Klick außerhalb schließt (mobil liegt die dunkle Fläche als ::before des Knopfs darüber)
    document.addEventListener('click', function (ev) {
      if (offen && !offen.dd.el.contains(ev.target)) schliessen(false);
    });
    document.addEventListener('keydown', function (ev) {
      if (!offen) return;
      if (ev.key === 'Escape') { ev.preventDefault(); schliessen(true); return; }
      if (ev.key === 'Tab' && offen.sheet) {
        // Bottom-Sheet: Fokus bleibt im Sheet
        var f = Array.prototype.filter.call(offen.dd.pop.querySelectorAll('button, input:not(:disabled)'), function (e) { return e.offsetParent !== null; });
        if (!f.length) return;
        var erst = f[0], letzt = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === erst) { ev.preventDefault(); letzt.focus(); }
        else if (!ev.shiftKey && document.activeElement === letzt) { ev.preventDefault(); erst.focus(); }
        else if (!offen.dd.pop.contains(document.activeElement)) { ev.preventDefault(); erst.focus(); }
      }
    });
    var wechsel = function () { if (offen) schliessen(false); };
    if (SHEET.addEventListener) SHEET.addEventListener('change', wechsel); else if (SHEET.addListener) SHEET.addListener(wechsel);

    if (eingabe) {
      eingabe.value = zustand.q;
      eingabe.addEventListener('input', function () {
        zustand.q = eingabe.value.trim();
        aendern(false);
      });
    }
    if (formular) {
      formular.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (eingabe) eingabe.blur();
        inUrl(true);
      });
    }
    sortWahl.value = zustand.sort;
    sortWahl.addEventListener('change', function () {
      zustand.sort = sortWahl.value;
      aendern(true);
    });
    sortBox.hidden = false;
    mehrBtn.addEventListener('click', function () {
      var ab = zustand.sichtbar;
      zustand.sichtbar += PRO_SEITE;
      zeichnen(ab);
    });
    Array.prototype.forEach.call(resetLinks, function (a) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); zuruecksetzen(); });
    });
    // Seitenzahlen und „Alle Übungen"-Link der Fassung ohne JavaScript ausblenden
    Array.prototype.forEach.call(app.querySelectorAll('[data-trr-ohnejs], [data-trr-serverleer]'), function (el) { el.hidden = true; });
  }

  ausUrl();
  indexFertig.then(function () {
    if (!uebungen.length) return; // leerer Index: Fassung ohne JavaScript (Text „erscheinen in Kürze") bleibt stehen
    ddUmbauen();
    verdrahten();
    app.classList.add('trh-app--js');
    zeichnen();
  }).catch(function () { /* oben gemeldet */ });
})();
